import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { forgotPasswordSchema } from "../../utils/error_schema";
import { resetPasswordRequest } from "../../services";
import { FloatingField, SubmitButton } from "../../components/Common";
import { resolveApiFormErrors } from "../../utils";
import { useFormValidation } from "../../utils/custom_hook";
import "./auth.css";

const INITIAL_FORM_VALUES = { email: "" };
const INITIAL_FORM_ERRORS = { email: "" };

export const ForgotPassword = () => {
  const navigate = useNavigate();
  const [resError, setResError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const {
    inputValue,
    inputError,
    setInputError,
    handleInputChange,
    validateForm,
  } = useFormValidation(
    INITIAL_FORM_VALUES,
    INITIAL_FORM_ERRORS,
    forgotPasswordSchema
  );

  const submit = async (e) => {
    e.preventDefault();
    const isValid = await validateForm();
    if (!isValid) return;

    setIsLoading(true);
    setResError("");
    setInputError(INITIAL_FORM_ERRORS);

    try {
      const res = await resetPasswordRequest(inputValue);
      if (res?.success) {
        navigate("/reset-password", { state: inputValue });
        return;
      }

      const { fieldErrors, displayError } = resolveApiFormErrors(
        res,
        INITIAL_FORM_ERRORS,
        { fallbackMessage: "Failed to send OTP on email" }
      );
      setInputError(fieldErrors);
      setResError(displayError);
    } catch {
      setResError("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout title="Forgot Password">
      <form onSubmit={submit}>
        <div className="text-2xl mb-8">Welcome to Fincobox</div>

        <div className="mb-4">
          <FloatingField
            controlId="forgot-email"
            label="Email"
            labelClass="_inInput_fx"
            type="email"
            id="forgot-email"
            placeholder="Email"
            name="email"
            maxLength={100}
            onChange={({ target: { name, value } }) =>
              handleInputChange(name, value)
            }
            focus={!!inputError.email}
            error={inputError.email}
            value={inputValue.email}
          />
        </div>

        <div className="mt-4">
          {resError && (
            <p className="invalid-feedback d-block">{resError}</p>
          )}
          <SubmitButton
            text="Send OTP"
            isLoading={isLoading}
            id="forgot-password-submit"
          />
        </div>

        <p className="mt-3 text-center">
          <Link to="/login">Back to Sign in</Link>
        </p>
      </form>
    </AuthLayout>
  );
};
